import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DetailViewEffects } from './detail-view.effects';
import { DetailViewStateKey } from './detail-view.model';
import { detailViewReducer } from './detail-view.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(DetailViewStateKey, detailViewReducer),
    EffectsModule.forFeature([DetailViewEffects]),
  ],
})
export class DetailViewStateModule {}
